<div class="facet">
    <facet-header caption="Orders"
        [facetId]="facetId">
        <button *ngIf="facetView === LIST_VIEW"
                climbFacetAction
                (click)="openFilter()"
                title="Filter Orders">
            <svg [climbIcon]="icons.magnifier"></svg>
        </button>

        <button data-automation-id="refresh-data-button"
                *ngIf="facetView === LIST_VIEW"
                climbFacetAction
                (click)="refreshData()"
                title="Refresh Data">
            <svg [climbIcon]="icons.arrowClockwise"></svg>
        </button>
    </facet-header>

    <div class="facet-body" *ngIf="facet.Privilege !== 'None'">
        <!-- Define the screens this facet can view -->
        <loading-overlay *ngIf="loading" [message]="loadingMessage"></loading-overlay>

        <ng-container *ngIf="facetView === LIST_VIEW">
            <climb-facet-toolbar>
                <climb-export-dropdown #exportDropdown
                                       [options]="orderTableOptions.options"
                                       [dataService]="dataService"
                                       [componentName]="componentName">
                    <button climbDropdownItem
                            [disabled]="!selectedAnimalOrders?.length"
                            (click)="generateOrderReport()">
                        Animal Order Report ({{selectedAnimalOrders?.length || 0}} Selected)
                    </button>
                </climb-export-dropdown>

                <climb-column-select [columnDef]="dataTableColumns$ | async"
                                     (onChange)="dataTable.columnSelectChanged($event)">
                </climb-column-select>
            </climb-facet-toolbar>
            <climb-data-table #dataTable
                              [dataService]="dataService"
                              [options]="orderTableOptions.options"
                              [(gridStateJson)]="facet.GridState"
                              [(selectedRows)]="selectedRows"
                              (selectedRowsChange)="selectedRowsChange($event)"
                              (selectedColumnsChange)="selectedColumnsChange($event)"
                              (addItemClick)="addItemClick()"
                              (detailLinkClick)="detailLinkClick($event)"
                              (columnStateChanged)="dataTableColumns.next($event)"
                              (stateChange)="exportDropdown.tableState = $event">
            </climb-data-table>
        </ng-container>

        <order-detail *ngIf="facetView === DETAIL_VIEW"
                      [facet]="facet"
                      [facetView]="facetView"
                      [order]="itemToEdit"
                      [pageState]="detailPaginator.pageState"
                      (exit)="exitDetail()"
                      (previous)="detailPreviousClicked()"
                      (next)="detailNextClicked()">
        </order-detail>
    </div>
</div>
